<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '90px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="加工组织">
              <a-select v-model="queryParams.organizationCode" option-filter-prop="children" option-label-prop="label" mode="multiple" :max-tag-text-length="2" :max-tag-count="1" @change="getFindList">
                <a-select-option v-for="(item) in inventOrg" :key="item.realValue" :value="item.realValue" :label="item.label">
                  {{ item.realValue }}-{{ item.label }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="异常发现日期" class="date-picker-form-item">
              <a-tooltip>
                <template slot="title">{{ $timeText(queryParams.abnormalityDiscoveredDate, 'YYYY-MM-DD') }}</template>
                <a-range-picker
                  v-model="queryParams.abnormalityDiscoveredDate"
                  valueFormat="YYYY-MM-DD"
                  allowClear
                />
              </a-tooltip>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="车间说明">
              <a-select v-model="queryParams.workshopCode" mode="multiple" option-filter-prop="children" :max-tag-text-length="2" :max-tag-count="1">
                <a-select-option v-for="(item) in workshopCodeListNew" :key="item.workshopCode">{{ `${item.workshopCode}-${item.workshopDesc}` }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="产线说明">
              <a-select v-model="queryParams.prodLineCode" mode="multiple" option-filter-prop="children" :max-tag-text-length="2" :max-tag-count="1">
                <a-select-option v-for="(item) in prodLineCodeListNew" :key="item.prodLineCode">{{ `${item.prodLineCode}-${item.prodLineDesc}` }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="生产工单">
              <global-select
                :value.sync="queryParams.job"
                selectType="selectSearch"
                requestApi="/mes/mesDiscreteJobs/allWipEntityName"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :dropdown-match-select-width="false"
                searchParam="wipEntityName"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="物料编码">
              <global-select
                :value.sync="queryParams.itemCode"
                selectType="selectAssembleMultipleSearch"
                requestApi="/scp/scpApsAbnormality/assemblyBox"
                :dropdown-match-select-width="false"
                :selectItem="{ value: 'selectedValue', label: 'bringOutDataOne' }"
                searchParam="itemCode"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="异常类型">
              <a-select v-model="queryParams.abnormalType" option-filter-prop="children" mode="multiple" :max-tag-text-length="2" :max-tag-count="1">
                <a-select-option v-for="(item) in abnormalTypeList" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="通知PMC">
              <a-select v-model="queryParams.pmcInformedFlag">
                <a-select-option v-for="(item) in pmcInformedFlagList" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="计划单号">
              <global-select
                :value.sync="queryParams.orderNoList"
                selectType="selectMultipleSearch"
                requestApi="/mes/mesDiscreteJobs/allOrderNo"
                :dropdown-match-select-width="false"
                :selectItem="{ value: 'realValue', label: 'label' }"
                searchParam="orderNo"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="handleQuery" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <download-modal :apiFun="apiScpApsAbnormalityNewExport" ref="download" />
      <a-button @click="$refs.createModal.show()" type="primary" v-hasPermi="['scp:scpApsAbnormality:add']">新建</a-button>
      <a-button @click="importExcelHandleOpen" type="primary" v-hasPermi="['scp:scpApsAbnormality:import']">导入</a-button>
      <a-button @click="handleExport" v-hasPermi="['scp:scpApsAbnormality:export']">导出</a-button>
      <!-- <a-button @click="importTemplate" v-hasPermi="['scp:scpApsAbnormality:template']">下载模板</a-button> -->
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <!-- <a-table
          ref="table"
          :columns="columns"
          :loading="pageParams.tableLoading"
          :data-source="typeList"
          :pagination="false"
          row-key="id"
          :scroll="{ x: 3200}"
        >
          <div
            v-for="item in columns"
            :slot="item.dataIndex"
            slot-scope="text, record"
            :key="item.dataIndex"
          >
            <span v-if="item.dataIndex === 'operation'">
              <a v-if="!isEdit || currentId !== record.id" @click="handleEdit(record)" v-hasPermi="['scp:scpApsAbnormality:edit']">编辑</a>
              <a v-if="!isEdit || currentId !== record.id" @click="handleDelete(record)" v-hasPermi="['scp:scpApsAbnormality:remove']" class="ml10">删除</a>
              <a v-if="isEdit && currentId === record.id" @click="handleSave(record)">保存</a>
              <a v-if="isEdit && currentId === record.id" @click="handleCancel(record)" class="ml10">取消</a>
            </span>
            <span v-else-if="item.type === 'select'">
              <span v-if="!isEdit || currentId !== record.id">{{ meaning(record, item.dataIndex) }}</span>
              <global-select
                v-if="isEdit && currentId === record.id"
                :value.sync="record[item.dataIndex]"
                :selectType="item.selectType ? item.selectType : 'select'"
                :requestApi="item.requestApi"
                :selectData="setArray(item.dataList)"
                :selectItem="{ value: item.value, label: item.label }"
                :searchParam="item.searchParam ? item.searchParam : ''"
                :allowClear="false"
                size="small"
                :assembleLabel="item.assembleLabel ? item.assembleLabel : false"
                @change="selectChange(item.dataIndex, record)"
              />
            </span>
            <span v-else-if="item.type === 'date'">
              <span v-if="!isEdit || currentId !== record.id">{{ record[item.dataIndex] }}</span>
              <a-date-picker v-if="isEdit && currentId === record.id" v-model="record[item.dataIndex]" size="small" />
            </span>
            <span v-else-if="item.type === 'input'">
              <span v-if="!isEdit || currentId !== record.id">{{ record[item.dataIndex] }}</span>
              <a-input v-if="isEdit && currentId === record.id" v-model="record[item.dataIndex]" size="small" />
            </span>
            <span v-else-if="item.type === 'inputNumber'">
              <span v-if="!isEdit || currentId !== record.id">{{ record[item.dataIndex] }}</span>
              <a-input-number v-if="isEdit && currentId === record.id" v-model="record[item.dataIndex]" :min="0" size="small" />
            </span>
            <span v-else-if="item.type === 'text'">{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
            <span v-else>{{ text }}</span>
          </div>
        </a-table> -->

        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 2000 }"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.ANOMALY_RECORD_LIST, // 表格方案配置唯一值
              }"
        >
          <template v-for="item in columns" :slot="item.dataIndex" slot-scope="text">
            <div :key="item.dataIndex">
              <span v-if="item.dataIndex === 'operation'">
                <a v-if="!isEdit || currentId !== text.record.id" @click="handleEdit(text.record)" v-hasPermi="['scp:scpApsAbnormality:edit']">编辑</a>
                <a v-if="!isEdit || currentId !== text.record.id" @click="handleDelete(text.record)" v-hasPermi="['scp:scpApsAbnormality:remove']" class="ml10">删除</a>
                <a v-if="isEdit && currentId === text.record.id" @click="handleSave(text.record)">保存</a>
                <a v-if="isEdit && currentId === text.record.id" @click="handleCancel(text.record)" class="ml10">取消</a>
              </span>
              <span v-else-if="item.dataIndex === 'liability'">
                <a-tooltip placement="top" v-if="!isEdit || currentId !== text.record.id">
                  <template slot="title">
                    <span>{{ text.record.liability }}</span>
                  </template>
                  <span class="liablity-text" v-if="!isEdit || currentId !== text.record.id">{{ text.record.liability }}</span>
                </a-tooltip>
                <global-select
                  size="small"
                  v-if="isEdit && currentId === text.record.id"
                  :value.sync="text.record.arrLiability"
                  selectType="selectMultipleSearch"
                  requestApi="/system/lookup/data/likeList"
                  :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                  :setParams="{ lookupType: 'MES_ABNORMAL_LIABILITY' }"
                  searchParam="lookupValue"
                />
              </span>
              <span v-else-if="item.type === 'select'">
                <span v-if="!isEdit || currentId !== text.record.id">{{ meaning(text.record, item.dataIndex) }}</span>
                <global-select
                  v-if="isEdit && currentId === text.record.id"
                  :value.sync="text.record[item.dataIndex]"
                  :selectType="item.selectType ? item.selectType : 'select'"
                  :requestApi="item.requestApi"
                  :selectData="setArray(item.dataList)"
                  :selectItem="{ value: item.value, label: item.label }"
                  :setParams="item.setParams ? setParamsHandle(text.record, item.dataIndex) : null"
                  :searchParam="item.searchParam ? item.searchParam : ''"
                  :allowClear="false"
                  size="small"
                  :assembleLabel="item.assembleLabel ? item.assembleLabel : false"
                  @change="(val, dataList) => selectChange(item.dataIndex, text.record, val, dataList)"
                  :dropdown-match-select-width="item.dropdownMatchSelectWidth === false ? false : true"
                  :sourse-field="item.sourseField"
                />
              </span>
              <span v-else-if="item.type === 'date'">
                <span v-if="!isEdit || currentId !== text.record.id">{{ text.record[item.dataIndex] }}</span>
                <a-date-picker v-if="isEdit && currentId === text.record.id" v-model="text.record[item.dataIndex]" size="small" />
              </span>
              <span v-else-if="item.type === 'dateTime'">
                <span v-if="!isEdit || currentId !== text.record.id">{{ text.record[item.dataIndex] }}</span>
                <a-date-picker
                  v-if="isEdit && currentId === text.record.id"
                  v-model="text.record[item.dataIndex]"
                  show-time
                  valueFormat="YYYY-MM-DD HH:mm:ss"
                  size="small"
                  @change="item.changeFun && item.changeFun(text.record)"
                />
              </span>
              <div v-else-if="item.type === 'input'">
                <a-tooltip placement="top" v-if="!isEdit || currentId !== text.record.id">
                  <template slot="title">
                    <span>{{ text.record[item.dataIndex] }}</span>
                  </template>
                  <div class="input-container">{{ text.record[item.dataIndex] }}</div>
                </a-tooltip>
                <a-input v-if="isEdit && currentId === text.record.id" v-model="text.record[item.dataIndex]" size="small" />
              </div>
              <span v-else-if="item.type === 'inputNumber'">
                <span v-if="!isEdit || currentId !== text.record.id">{{ text.record[item.dataIndex] }}</span>
                <a-input-number v-if="isEdit && currentId === text.record.id" v-model="text.record[item.dataIndex]" :min="0" size="small" />
              </span>
              <span v-else-if="item.type === 'text'">{{ text.text && $moment(text.text).format('YYYY-MM-DD HH:mm:ss') }}</span>
              <span v-else>{{ text.text }}</span>
            </div>
          </template>
        </ls-api-table>
        <!-- 底部分页按钮 -->
        <!-- <Page ref="page" :pageParams.sync="pageParams" @getList="getList" /> -->
        <anomaly-record-add
          ref="createModal"
          :inventOrg="inventOrg"
          :abnormalTypeList="abnormalTypeList"
          :pmcInformedFlagList="pmcInformedFlagList"
          @handle-success="handleOk"
        />
      </div>
      <!-- 上传文件 -->
      <a-modal
        :title="upload.title"
        :visible="excelVisible"
        @ok="importExcelHandleCancel"
        @cancel="importExcelHandleCancel"
      >
        <a-upload-dragger
          name="file"
          accept=".xlsx, .xls"
          :multiple="true"
          :headers="upload.headers"
          :action="upload.url + '?updateSupport=' + upload.updateSupport"
          @change="importExcelHandleChange"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
          </p>
          <p class="ant-upload-text">
            请将文件拖拽到此处上传
          </p>
          <p class="ant-upload-hint">
            支持单个或批量上传，也可以点击后选择文件上传
          </p>
        </a-upload-dragger>
      </a-modal>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import { apiScpApsAbnormalityUpdate, apiScpApsAbnormalityDelete, apiBomWorkshopFindList, apiBomProdLineFindList, apiScpApsAbnormalityList, apiScpApsAbnormalityNewExport } from '@/api/mes/basedata/anomalyRecord'
import AnomalyRecordAdd from './components/anomaly-record-add'
import Cookies from 'js-cookie';
import { generateLsTableResData } from '@/utils/util.js';
import moment from 'moment'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import cloneDeep from 'lodash.clonedeep'

export default {
  name: 'AnomalyRecord',
  components: {
    DownloadModal,
    AnomalyRecordAdd
  },
  data () {
    const token = (process.env.NODE_ENV === "development" || localStorage.getItem('isFromSystemLogin') === 'true') ? localStorage.getItem('token') : Cookies.get('Admin-Token')
    const Authorization = token ? 'Bearer ' + token : undefined;
    return {
      apiScpApsAbnormalityNewExport,
       // 表格配置
       tableProps: {
        requestApi: generateLsTableResData(apiScpApsAbnormalityList, true),
        pageCurrent: true
      },
      // 导入excel
      excelVisible: false,
      // 用户导入参数
      upload: {
        // 是否显示弹出层（用户导入）
        open: false,
        // 弹出层标题（用户导入）
        title: '导入Excel',
        // 是否禁用上传
        isUploading: false,
        // 是否更新已经存在的用户数据
        updateSupport: 0,
        // 设置上传的请求头部
        headers: { Authorization: Authorization },
        // 上传的地址
        url: process.env.VUE_APP_API_BASE_URL + '/scp/scpApsAbnormality/import'
      },
      isEdit: false,
      currentId: "",
      pageParams: {
        automatic: false,
        pageUrl: '/scp/scpApsAbnormality/list',
        tableLoading: false
      },
      // 控制搜索展开
      advanced: true,
      // 查询参数
      queryParams: {
        organizationCode: undefined,
        abnormalityDiscoveredDate: undefined,
        abnormalityDiscoveredDateFrom: undefined,
        abnormalityDiscoveredDateTo: undefined,
        workshopCode: undefined,
        prodLineCode: undefined,
        job: undefined,
        itemCode: undefined,
        abnormalType: undefined,
        pmcInformedFlag: undefined
      },
      // 快码表格数据
      typeList: [],
      // 表格字段
      columns: [
        {
          title: '异常发现日期',
          dataIndex: 'abnormalityDiscoveredDate',
          scopedSlots: { customRender: 'abnormalityDiscoveredDate' },
          width: 160,
          align: 'center',
          type: "date"
        },
        {
          title: '加工组织',
          dataIndex: 'organizationCode',
          scopedSlots: { customRender: 'organizationCode' },
          width: 170,
          align: 'center',
          type: "select",
          selectType: "selectAssemble",
          assembleLabel: true,
          dataList: 'inventOrg',
          value: 'realValue',
          label: 'label',
          ellipsis: true,
          dropdownMatchSelectWidth: false
        },
        {
          title: '供应商',
          width: 150,
          dataIndex: 'supplierName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '车间说明',
          dataIndex: 'workshopCode',
          scopedSlots: { customRender: 'workshopCode' },
          width: 160,
          ellipsis: true,
          type: "select",
          setParams: true,
          requestApi: '/bom/bomWorkshop/findList',
          value: 'workshopCode',
          label: 'workshopDesc',
          sourseField: "res"
        },
        {
          title: '产线说明',
          dataIndex: 'prodLineCode',
          scopedSlots: { customRender: 'prodLineCode' },
          width: 160,
          ellipsis: true,
          type: "select",
          setParams: true,
          requestApi: '/bom/bomProdLine/findList',
          value: 'prodLineCode',
          label: 'prodLineDesc',
          sourseField: "res"
        },
        {
          title: '班组长',
          width: 150,
          dataIndex: 'monitor',
          scopedSlots: { customRender: 'monitor' },
          ellipsis: true,
          type: "input",
          align: 'center'
        },
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          scopedSlots: { customRender: 'itemCode' },
          width: 170,
          align: 'center',
          type: "select",
          setParams: true,
          selectType: "selectAssembleSearch",
          requestApi: "/mes/mesDiscreteJobs/assemblyBox",
          searchParam: "itemCode",
          value: 'selectedValue',
          label: 'bringOutDataOne',
          ellipsis: true,
          dropdownMatchSelectWidth: false
        },
        {
          title: '规格描述',
          width: 150,
          dataIndex: 'specification',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '生产工单',
          dataIndex: 'job',
          scopedSlots: { customRender: 'job' },
          width: 170,
          align: 'center',
          type: "select",
          selectType: 'selectSearch',
          requestApi: "/mes/mesDiscreteJobs/allWipEntityName",
          value: 'realValue',
          label: 'label',
          searchParam: 'wipEntityName',
          setParams: true,
          ellipsis: true
        },
        {
          title: '计划单号',
          dataIndex: 'orderNo',
          width: 170,
          align: 'center',
          ellipsis: true
        },
        {
          title: '异常类型',
          dataIndex: 'abnormalType',
          scopedSlots: { customRender: 'abnormalType' },
          width: 170,
          align: 'center',
          type: "select",
          dataList: 'abnormalTypeList',
          value: 'lookupCode',
          label: 'lookupValue',
          ellipsis: true,
          dropdownMatchSelectWidth: false
        },
        {
          title: '异常原因说明',
          dataIndex: 'abnormalReason',
          scopedSlots: { customRender: 'abnormalReason' },
          width: 170,
          align: 'center',
          type: "input",
          ellipsis: true
        },
        {
          title: '责任归属',
          width: 200,
          dataIndex: 'liability',
          scopedSlots: { customRender: 'liability' },
          align: 'center',
          type: "input",
          ellipsis: true
        },
        {
          title: '影响数量(套)',
          width: 120,
          dataIndex: 'affectedQty',
          scopedSlots: { customRender: 'affectedQty' },
          align: 'center',
          type: "inputNumber",
          ellipsis: true
        },
        {
          title: '影响工时(时)',
          width: 120,
          dataIndex: 'affectedWorkingHours',
          scopedSlots: { customRender: 'affectedWorkingHours' },
          align: 'center',
          type: "inputNumber",
          ellipsis: true
        },
        {
          title: '相关配合事项',
          width: 120,
          dataIndex: 'relatedCoordinatedMatter',
          scopedSlots: { customRender: 'relatedCoordinatedMatter' },
          align: 'center',
          type: "input",
          ellipsis: true
        },
        {
          title: '需求完成时间',
          width: 170,
          dataIndex: 'completionDate',
          scopedSlots: { customRender: 'completionDate' },
          align: 'center',
          type: "dateTime",
          changeFun: (record) => {
            this.setStatusByCompletionAndActualCompletionDate(record)
          }
        },
        {
          title: '实际完成时间',
          width: 170,
          dataIndex: 'actualCompletionDate',
          scopedSlots: { customRender: 'actualCompletionDate' },
          align: 'center',
          type: "dateTime",
          changeFun: (record) => {
            this.setStatusByCompletionAndActualCompletionDate(record)
          }
        },
        {
          title: '状态',
          width: 160,
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          align: 'center',
          type: "select",
          requestApi: "/system/lookup/data/list",
          value: 'lookupCode',
          label: 'lookupValue',
          setParams: true
        },
        {
          title: '通知PMC',
          dataIndex: 'pmcInformedFlag',
          scopedSlots: { customRender: 'pmcInformedFlag' },
          width: 170,
          align: 'center',
          type: "select",
          dataList: 'pmcInformedFlagList',
          value: 'lookupCode',
          label: 'lookupValue',
          ellipsis: true
        },
        {
          title: '最后修改人',
          width: 120,
          dataIndex: 'updateName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '最后修改时间',
          dataIndex: 'updateTime',
          scopedSlots: { customRender: 'updateTime' },
          width: 170,
          align: 'center',
          type: "text",
          ellipsis: true
        },
        {
          title: '创建人',
          width: 120,
          dataIndex: 'createName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          width: 170,
          align: 'center',
          type: "text",
          ellipsis: true
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          stickyFixed: 'right'
        }
      ],
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          this.selectedRows = selectedRows
        },
        onSelect: (record, selected, selectedRows) => {},
        onSelectAll: (selected, selectedRows, changeRows) => {}
      },
      workshopCodeListNew: [], // 车间编码
      prodLineCodeListNew: [], // 产线编码
      abnormalTypeList: [], // 异常类型
      pmcInformedFlagList: [], // 通知PMC
      statusList: []
    }
  },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  created () {
    // const arr = []
    // arr.push(this.organizationCodeOrigin)
    // this.queryParams.organizationCode = arr
    // this.getFindList(this.queryParams.organizationCode)

    this.getLookupList('APS_ABNORMAL_TYPE', 'abnormalTypeList')
    this.getLookupList('APS_PMC_INFORMED_FLAG', 'pmcInformedFlagList')
    this.getLookupList('APS_ABNORMAL_STATUS', 'statusList')
  },
  mounted () {
    this.onSearch()
  },
  methods: {
    // 表单搜索
    onSearch () {
      this.queryParams.abnormalityDiscoveredDateFrom = this.queryParams.abnormalityDiscoveredDate && this.queryParams.abnormalityDiscoveredDate[0] ? (this.queryParams.abnormalityDiscoveredDate[0] + " 00:00:00") : ""
      this.queryParams.abnormalityDiscoveredDateTo = this.queryParams.abnormalityDiscoveredDate && this.queryParams.abnormalityDiscoveredDate[1] ? (this.queryParams.abnormalityDiscoveredDate[1] + " 23:59:59") : ""
      const queryObj = cloneDeep(this.queryParams)
      if (queryObj?.abnormalityDiscoveredDate) { delete queryObj.abnormalityDiscoveredDate }
      this.$refs.dataTable.searchParams = queryObj;
      this.$refs.dataTable.getData();
      this.isEdit = false
    },
    // 删除
    handleDelete (row) {
      const self = this
      this.$confirm({
        title: '警告',
        content: `真的要删除 id为${row.id}的数据项吗?`,
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          apiScpApsAbnormalityDelete(row.id).then((response) => {
            if (response.code === 200) {
              self.$message.success('删除成功!')
              self.onSearch()
            } else {
              self.$message.error(response.msg)
            }
          })
        }
      })
    },
    // 编辑
    handleEdit (record) {
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return;
      }

      this.getFindList(record.organizationCode)
      if (record.liability) {
        this.$set(record, 'arrLiability', record.liability.split(','))
      } else {
        this.$set(record, 'arrLiability', [])
      }

      this.isEdit = true;
      this.currentId = record.id;
    },
    // 编辑-保存
    handleSave (record) {
      const tempParams = cloneDeep(record)
      if (Array.isArray(tempParams.arrLiability) && tempParams.arrLiability.length > 0) {
        tempParams.liability = tempParams.arrLiability.join(',')
      } else {
        tempParams.liability = ''
      }
      apiScpApsAbnormalityUpdate(tempParams).then(response => {
        if (response.code === 200) {
          this.$message.success('保存成功')
          this.onSearch()
        } else {
          this.$message.error(response.msg)
        }
      })
    },
    // 取消
    handleCancel (record) {
      this.onSearch()
    },
    /** 查询列表 */
    getList (data) {
      this.typeList = data
      this.isEdit = false
    },
    // 新增/修改框事件
    handleOk () {
      this.onSearch()
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.onSearch()
    },
    /** 重置按钮操作 */
    resetQuery () {
      const arr = []
      arr.push(this.organizationCodeOrigin)
      this.queryParams = {
        organizationCode: arr,
        abnormalityDiscoveredDate: undefined,
        abnormalityDiscoveredDateFrom: undefined,
        abnormalityDiscoveredDateTo: undefined,
        workshopCode: undefined,
        prodLineCode: undefined,
        job: undefined,
        itemCode: undefined,
        abnormalType: undefined,
        pmcInformedFlag: undefined
      }
      this.handleQuery()
    },
    getFindList (val) {
      this.$set(this.queryParams, 'workshopCode', undefined)
      this.$set(this.queryParams, 'prodLineCode', undefined)
      // 车间编码
      apiBomWorkshopFindList({ organizationCode: val }).then(res => {
        this.workshopCodeListNew = res
      })
      // 产线编码
      apiBomProdLineFindList({ organizationCode: val }).then(res => {
        this.prodLineCodeListNew = res
      })
    },
    meaning (record, dataIndex) {
      if (dataIndex === "organizationCode") {
        return record.organizationName
      }
      if (dataIndex === "abnormalType") {
        return record.abnormalTypeDesc
      }
      if (dataIndex === "pmcInformedFlag") {
        return record.pmcInformedFlagDesc
      }
      if (dataIndex === "status") {
        return record.statusName
      }
      if (dataIndex === "workshopCode") {
        return record.workshopDesc
      }
      if (dataIndex === "prodLineCode") {
        return record.prodLineDesc
      }
      return record[dataIndex]
    },
    selectChange (val, record, selectData, selectList) {
      if (val === "organizationCode") {
        this.getFindList(record.organizationCode)
      }
      // 生产工单选择
      if (val === "job") {
        this.handleJobSelectSetOrderNo(record, selectData, selectList)
      }
    },
    handleJobSelectSetOrderNo (record, data, list) {
      const tempItem = list.find(item => item.realValue === data)
      record.orderNo = tempItem ? tempItem.bringOutDataOne : ''
    },
    setParamsHandle (record, dataIndex) {
      if (dataIndex === "status") {
        return { lookupType: 'APS_ABNORMAL_STATUS' }
      }
      if (dataIndex === "workshopCode") {
        return { organizationCode: record.organizationCode }
      }
      if (dataIndex === "prodLineCode") {
        return { organizationCode: record.organizationCode }
      }
      if (dataIndex === "itemCode") {
        return { organizationCode: record.organizationCode }
      }
      if (dataIndex === 'job') {
        return { organizationCode: record.organizationCode }
      }
    },
    setArray (arr) {
      return this[arr]
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 导入excel */
    importExcelHandleChange (info) {
      const status = info.file.status
      if (status !== 'uploading') {
      }
      if (status === 'done') {
        this.$message.success(`${info.file.name}: ${info.file.response.msg}`)
      } else if (status === 'error') {
        this.$message.error(`${info.file.name}: ${info.file.response.msg}`)
      }
    },
    /** 导入excel窗体关闭 */
    importExcelHandleCancel (e) {
      this.excelVisible = false
      // 关闭后刷新列表
      this.handleQuery()
    },
    /** 导入excel窗体开启 */
    importExcelHandleOpen (e) {
      this.excelVisible = true
    },
    /** 下载模板操作 */
    importTemplate () {
      this.download('scp/scpApsAbnormality/template', {
        ...this.queryParams
      }, `生产异常记录导入模板_${new Date().getTime()}.xlsx`)
    },
    // 导入导出excel
    /** 导出按钮操作 */
    handleExport () {
      const params = cloneDeep(this.queryParams)
      if (params?.abnormalityDiscoveredDate) { delete params.abnormalityDiscoveredDate }
      this.$refs.download.openModal(params)
      // this.download('scp/scpApsAbnormality/export', {
      //   ...this.queryParams
      // }, `生产异常记录_${new Date().getTime()}.xlsx`)
    },
    getLookupList (type, arr) {
      const lookupQueryParams = {
        lookupType: type,
        current: 1,
        pageSize: 100
      }
      this.getLookupListData(lookupQueryParams).then().then(response => {
        this[arr] = response.rows
      })
    },
    setStatusByCompletionAndActualCompletionDate (record) {
      const momentCompletionDate = moment(record.completionDate).startOf('day')
      const momentActualCompletionDate = moment(record.actualCompletionDate).startOf('day')
      if (momentCompletionDate.isBefore(momentActualCompletionDate)) {
        record.status = 'DELAY'
      } else if (momentCompletionDate.isAfter(momentActualCompletionDate)) {
        record.status = 'BEFOREHAND'
      } else {
        record.status = 'ONTIME'
      }
    }
  }
}
</script>

<style scoped lang="less">
.table-page-search-wrapper {
  /deep/.date-picker-form-item {
    width: 100%;
  }
  /deep/.date-picker-input {
    width: 100%;
  }
}
.page-header-content {
  /deep/.ant-select{
    width: 140px;
  }
  /deep/.ant-calendar-picker{
    min-width: 150px !important;
  }
}
/deep/.ant-calendar-picker{
  width: 100% !important
}
/deep/.ant-form-item-control-wrapper{
  width: 25% !important
}
.input-container {
  overflow: hidden;
  text-overflow: ellipsis;
}
.liablity-text {
  display: block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}
/deep/.ant-drawer-content-wrapper{
  .ant-form-item{
    .ant-form-item-control-wrapper{
      width: 83.33% !important
    }
  }
}
</style>
